/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_I18n_Title2Inputs */

const en_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multilingual conversations`)
};

const ar_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محادثات متعددة اللغات`)
};

const bn_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বহুভাষিক কথোপকথন`)
};

const de_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrsprachige Gespräche`)
};

const es_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones multilingües`)
};

const fr_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations multilingues`)
};

const pt_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas multilingues`)
};

const zh_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多语言对话`)
};

const tr_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok dilli sohbetler`)
};

const ru_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Многоязычные диалоги`)
};

const pl_svc_messaging_bots_i18n_title2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowy wielojęzyczne`)
};

/**
* | output |
* | --- |
* | "Multilingual conversations" |
*
* @param {Svc_Messaging_Bots_I18n_Title2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_i18n_title2 = /** @type {((inputs?: Svc_Messaging_Bots_I18n_Title2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_I18n_Title2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "de") return de_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "es") return es_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_i18n_title2(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_i18n_title2(inputs)
	return en_svc_messaging_bots_i18n_title2(inputs)
});
export { svc_messaging_bots_i18n_title2 as "svc_messaging-bots_I18N_title" }